module.exports = __webpack_public_path__ + "static/CircularStd-Bold-97ca95083f8be0c5d7ee9907cfe28af1.woff2";